import React, {useEffect} from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";
import CodeAuditResult from "./CodeAuditResult.jsx";
import { useSelector, useDispatch } from "react-redux";
import { updateOverview } from "../../state/reducers/codeOverview";
import { resetAudit } from "../../state/reducers/codeAudit.js";

function CodeAudit() {

  const showOverview = useSelector((state) => state.codeOverview.showOverview)
  const showCodeAudit = useSelector((state) => state.codeAudit.showCodeAudit)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateOverview(false))
    return(() => {
      dispatch(resetAudit())
    })
  }, [])
  

  return (
    <>
      {!showOverview && !showCodeAudit && <CloneRepo />}
      {showCodeAudit && <CodeAuditResult />}
    </>
  );
}

export default CodeAudit;